(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dh-guest-withdrawal"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dh-withdrawal]').forEach((root) => {
    const form = root.querySelector('form');
    const details = root.querySelector('[data-dh-details]');
    const review = root.querySelector('[data-dh-review-step]');
    if (!form || !details || !review) return;

    const by = (selector) => root.querySelector(selector);
    const name = form.querySelector('[name="contact[name]"]');
    const email = form.querySelector('[name="contact[email]"]');
    const order = by('[data-dh-order]');
    const other = by('[data-dh-other]');
    const goods = by('[data-dh-goods]');
    const explanation = by('[data-dh-explanation]');
    const body = by('[data-dh-body]');
    const statement = by('[data-dh-statement]');
    const validation = by('[data-dh-validation]');
    const confirm = by('[data-dh-confirm]');
    let reviewing = false;
    let reviewedStatement = '';
    let submitting = false;

    const createStatement = () => {
      const missing = root.dataset.dhNotSupplied;
      const lines = [
        `${root.dataset.dhIntro} ${name.value.trim()} — ${goods.value.trim()}.`,
        `${root.dataset.dhOrderLabel}: ${order.value.trim() || missing}.`,
        `${root.dataset.dhOtherLabel}: ${other.value.trim() || missing}.`,
        `${root.dataset.dhEmailLabel}: ${email.value.trim()}.`
      ];
      if (explanation.value.trim()) lines.push(`${root.dataset.dhDetailsLabel}: ${explanation.value.trim()}.`);
      return lines.join('\n');
    };

    const validDetails = () => {
      validation.hidden = true;
      if (!name.value.trim()) {
        validation.textContent = root.dataset.dhNameError;
        validation.hidden = false;
        name.focus();
        return false;
      }
      if (!goods.value.trim()) {
        validation.textContent = root.dataset.dhGoodsError;
        validation.hidden = false;
        goods.focus();
        return false;
      }
      if (!form.reportValidity()) return false;
      if (order.value.trim() || other.value.trim()) return true;
      validation.textContent = root.dataset.dhIdentityError;
      validation.hidden = false;
      order.focus();
      return false;
    };

    const showReview = () => {
      if (!validDetails()) return;
      reviewedStatement = createStatement();
      body.value = reviewedStatement;
      statement.textContent = reviewedStatement;
      reviewing = true;
      details.hidden = true;
      review.hidden = false;
      confirm.disabled = false;
      by('[data-dh-review-heading]').focus();
    };

    by('[data-dh-review]').addEventListener('click', showReview);
    by('[data-dh-edit]').addEventListener('click', () => {
      reviewing = false;
      reviewedStatement = '';
      confirm.disabled = true;
      review.hidden = true;
      details.hidden = false;
      name.focus();
    });
    form.addEventListener('submit', (event) => {
      if (!reviewing) {
        event.preventDefault();
        showReview();
        return;
      }
      const detailsValid = validDetails();
      if (!detailsValid || createStatement() !== reviewedStatement) {
        event.preventDefault();
        reviewing = false;
        reviewedStatement = '';
        confirm.disabled = true;
        review.hidden = true;
        details.hidden = false;
        if (detailsValid) {
          validation.textContent = root.dataset.dhChangedError;
          validation.hidden = false;
        }
        return;
      }
      if (submitting) {
        event.preventDefault();
        return;
      }
      body.value = reviewedStatement;
      submitting = true;
      confirm.disabled = true;
      setTimeout(() => {
        submitting = false;
        confirm.disabled = false;
      }, 10000);
    });
    root.classList.add('dh-withdrawal--ready');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
